import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import { RouteWithLayout } from './components';
import { User as UserLayout, Minimal as MinimalLayout } from './layouts';

import apiManager from './ApiManager';

import {
  NotFound as NotFoundView,
//   Subscriptions as SubscriptionsView,
  SubscriptionSuccess as SubscriptionSuccessView,
  SubscriptionError as SubscriptionErrorView,
  Account as AccountView,
  ResetPassword as ResetView,
  ChangePassword,
  TermsAndConditions as TermsView,
//   Impersonate as ImpersonateView,
  Error as ErrorView,
  HomeUser as HomeView,
  MyClasses as MyClassesView,
  CertOfCompletion,
  SignUpVerification,
  Logout,
  Administration,
} from './views';

class UserRoutes extends React.PureComponent {
  constructor(props) {
    super(props);
    const { user, appProps } = this.props;
    this.state = {
      user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : user ? user : {},
      apiManager,
      appProps,
    };
    this.updateUser = this.updateUser.bind(this);
  }

  async componentWillReceiveProps(nextProps) {
    //   const {user} = nextProps;

  }

  async componentDidUpdate() {
    //   const {user} = this.props;

  }

  updateUser(user) {
    user.initials = `${user.firstname.toUpperCase().charAt(0)}${user.lastname.toUpperCase().charAt(0)}`;
    this.setState({ user });
    localStorage.setItem('user', JSON.stringify(user));
  }

  render() {
    const { apiManager, appProps } = this.state;
    const { user, history } = this.props;
 
    return (
      <Switch>
        <RouteWithLayout
          component={HomeView}
          exact
          layout={UserLayout}
         // path="/"
          path={["/", "/home", "/signin", "/register", "/signup"]} 
          user={user}
          apiManager={apiManager}
          updateUser={this.updateUser}
          history={history}
        />
        {/* <RouteWithLayout
          component={HomeView}
          exact
          layout={UserLayout}
          path="/home"
          user={user}
          apiManager={apiManager}
          history={history}
        /> */}
        <RouteWithLayout
          component={AccountView}
          exact
          layout={UserLayout}
          path="/account"
          user={user}
          updateUser={this.updateUser}
          apiManager={apiManager}
        />
        <RouteWithLayout
          component={HomeView}
          exact
          layout={UserLayout}
          path="/subscription"
          user={user}
          apiManager={apiManager}
        />
        <RouteWithLayout
          component={SubscriptionSuccessView}
          exact
          layout={UserLayout}
          path="/subscription/success/*"
          user={user}
          apiManager={apiManager}
        />
        <RouteWithLayout
          component={SubscriptionErrorView}
          exact
          layout={UserLayout}
          path="/subscription/error"
          user={user}
          apiManager={apiManager}
        />
        <RouteWithLayout
          component={MyClassesView}
          exact
          layout={UserLayout}
          path="/myclasses"
          user={user}
          apiManager={apiManager}
        />
        <RouteWithLayout
          component={CertOfCompletion}
          exact
          layout={UserLayout}
          path="/myclasses/completion/print/option"
          user={user}
          apiManager={apiManager}
        />
        <Route
          exact
          path="/signout"
          render={(props) => (
            <Logout {...props} updateUser={this.updateUser} appProps={appProps} history={history} />
          )}
        />
        {/* <Route
          exact
          path="/impersonate"
          render={(props) => <ImpersonateView {...props} updateUser={this.updateUser} apiManager={apiManager} />}
        /> */}
        <Route exact path="/terms-and-conditions" render={(props) => <TermsView {...props} />} />
        {/* <Route exact path="/reset-password" render={(props) => <ResetView {...props} user={user} apiManager={apiManager} updateUser={this.updateUser} />} /> */}
        
        <RouteWithLayout
          component={ResetView}
          exact
          layout={UserLayout}
          path="/reset-password"
          user={user}
          apiManager={apiManager}
          updateUser={this.updateUser}
        />    
        <RouteWithLayout
          component={ChangePassword}
          exact
          layout={UserLayout}
          path="/change-password"
          user={user}
          apiManager={apiManager}
        />  
        <RouteWithLayout
          component={Administration}
          exact
          layout={UserLayout}
          path="/administration"
          user={user}
          apiManager={apiManager}
        />   
        <Route
          exact
          path="/verification"
          render={(props) => <SignUpVerification {...props} updateUser={this.updateUser} />}
        />
        <RouteWithLayout component={NotFoundView} exact layout={MinimalLayout} path="/sorry-page-not-found" />
        <RouteWithLayout component={ErrorView} exact layout={MinimalLayout} path="/error" />
        <Redirect to="/sorry-page-not-found" />
      </Switch>
    );
  }
}

UserRoutes.propTypes = {
  user: PropTypes.object,
};

export default UserRoutes;
